import { render, staticRenderFns } from "./PropertyOverview.vue?vue&type=template&id=2147c15c&scoped=true&"
import script from "./PropertyOverview.vue?vue&type=script&lang=ts&"
export * from "./PropertyOverview.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyOverview.vue?vue&type=style&index=0&id=2147c15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147c15c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
